import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, Button, Grid, Box } from '@mui/material';


const DriverHoursDialog = ({ title, submitDate, stopType, onClose, onSubmit, ...props }) => {

    const [driverHours, setDriverHours] = useState(0);

    const onClickSubmit = () => {
        onSubmit(submitDate, stopType, driverHours);
        onClose();
    }
    return (
        <Dialog {...props} fullScreen>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField type="number" fullWidth  value={driverHours} onChange={(e) => setDriverHours(parseFloat(e.target.value))} label='# of Hours' variant='outlined' />
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth disabled={driverHours == 0 ? true : false} onClick={onClickSubmit} variant='contained'>Submit</Button>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default DriverHoursDialog;